import React from 'react'
import { useStyles } from './Badge.styles'

interface IBadge {
  title: string
}

export const Badge = ({ title }: IBadge) => {
  const classes = useStyles()

  return <div className={classes.badge}>{title}</div>
}
